let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cRCPg")).then(() => parcelRequire('e5DTv'));